import React, { useCallback } from 'react';
import { InvalidTokenResult } from 'components/auth';
import { useNavigate } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';

const InvalidResetToken = () => {
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    navigate(ADMIN_ROUTES.adminForgotPassword);
  }, [navigate]);

  return <InvalidTokenResult showButton={true} onButtonClick={onButtonClick} />;
};

export default InvalidResetToken;
